// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0baac773","977":"01d32556"}[chunkId] + ".chunk.js";
};